import { useState, createContext } from 'react';

import { CRUDableType } from '@/meta';

export interface Deletable {
  type: CRUDableType;
  publicId: string;
  entityName: string | undefined;
  onDeleteSuccess: () => void;
}

export type DeleteDispatch = {
  dispatch: (arg: Deletable) => void;
};

function useDeleteEntityController(): Deletable & DeleteDispatch {
  const [state, setState] = useState<Deletable>({
    type: 'capability',
    publicId: '',
    entityName: '',
    onDeleteSuccess: () => {},
  });

  return {
    ...state,
    dispatch: (newState: Deletable) => setState(newState),
  };
}

export const DeleteEntityContext = createContext<Deletable & DeleteDispatch>({
  type: 'capability',
  publicId: '',
  entityName: '',
  onDeleteSuccess: () => {},
  dispatch: () => {},
});

export default useDeleteEntityController;
